import { ProductListItemProduct } from '~/src/common/components/ProductListItem/types';
import { useGetProductCartFreeArticleCoupons } from '~/src/common/hooks/cart/useGetCartFreeArticleCoupons';
import Toaster from '~/src/common/services/Toaster';
import { BatchDiscountMessage } from '~/src/common/services/Toaster/Toast';
import { ImageFormatIds, ImageParams } from '~/src/common/typings/image';
import { getImageUrlFromFormat } from '~/src/common/utils/cloudinary';
import { getProductPromoWithBulkDiscount } from '~/src/common/utils/product';
import { Product } from '~/src/typings/products/types';

export const useNotifyNthPromo = (
  product: Pick<Product | ProductListItemProduct, 'id' | 'images' | 'promo' | 'pricing'>,
) => {
  const freeQuantity = useGetProductCartFreeArticleCoupons(product.id);

  const promo = getProductPromoWithBulkDiscount(product);

  const handleNotifyNthPromo = ({
    quantity,
    currentQuantity,
  }: {
    quantity: number;
    currentQuantity: number;
  }) => {
    const nthQuantity = promo?.conditions?.nthQuantity;

    // on vérifie ici que la quantité du produit (moins les produits offerts)
    // est égale à la quantité qui active la promo lot virtuel (ex: Le 3ème à 1€)
    const isPromoQuantityReached = quantity - freeQuantity === nthQuantity;
    const isQuantityAdded = currentQuantity < quantity; // La promo n'est pas affichée quand la quantité décroit

    if (
      // aussi appellées promo "bogof" (buy one get one free)
      promo?.mechanism === 'BATCH_DISCOUNT' &&
      isPromoQuantityReached &&
      isQuantityAdded
    ) {
      Toaster.notify({
        image: getImageUrlFromFormat(product.images[0], ImageFormatIds.Square, ImageParams.list),
        message: BatchDiscountMessage({ promo }),
      });
    }
  };

  return handleNotifyNthPromo;
};
